import { InjectionToken } from "@angular/core";

export const DEFAULT_DATE_FORMAT = new InjectionToken<string>('defaultDateFormat');
export const DEFAULT_NOTIFICATIONS_DISPLAYTIME = new InjectionToken<number>('defaultDisplayTime');
export const DEFAULT_HTTP_REQUEST_TIMEOUT = new InjectionToken<number>('defaultTimeout');
export const DEFAULT_PAGE_SIZE = new InjectionToken<number>('defaultPageSize');
export const DEFAULT_PAGE_SIZES = new InjectionToken<number>('defaultPageSizes');

